import React, { useEffect, useMemo, useState } from "react";

import { Modal } from "../../../../../components/common/Modal";
import { Button } from "../../../../../components/common/Button";

type Props = {
    isOpen: boolean;
    user: any | null;

    pending?: boolean;
    error?: boolean;
    errorMessage?: string | null;

    onClose: () => void;
    onConfirm: (payload: { email: string }) => void;
};

// ---- helpers
const normalizeEmail = (v: any) =>
    String(v ?? "")
        .trim()
        .toLowerCase();

const ResetUserPasswordModal: React.FC<Props> = ({
                                                     isOpen,
                                                     user,
                                                     pending,
                                                     error,
                                                     errorMessage,
                                                     onClose,
                                                     onConfirm,
                                                 }) => {
    const userLabel = user?.email || user?.name || "пользователя";

    const initialEmail = useMemo(() => normalizeEmail(user?.email), [user?.email]);

    const [email, setEmail] = useState<string>("");

    useEffect(() => {
        if (!isOpen) return;
        setEmail(initialEmail);
    }, [isOpen, initialEmail]);

    const confirmDisabled = !email || !!pending;

    return (
        <Modal
            isOpen={isOpen}
            onClose={pending ? undefined : onClose}
            title="Сбросить пароль"
        >
            <div className="text-sm text-slate-700">
                Пользователь: <span className="font-semibold">{userLabel}</span>
            </div>

            <div className="mt-4">
                <div className="text-xs font-semibold text-slate-600 mb-2">Email для сброса</div>

                <input
                    type="email"
                    className="w-full rounded-xl border border-slate-200 px-3 py-2 text-sm outline-none focus:ring-2 focus:ring-slate-200"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    disabled={!!pending}
                    placeholder="user@example.com"
                />

                <div className="mt-2 text-xs text-slate-500 leading-relaxed">
                    Мы отправим письмо со ссылкой для смены пароля на указанный email.
                </div>

                {error ? (
                    <div className="mt-3 rounded-xl border border-red-200 bg-red-50 px-3 py-2 text-xs text-red-600">
                        {errorMessage || "Ошибка при отправке письма"}
                    </div>
                ) : null}
            </div>

            <div className="mt-5 flex justify-end gap-2">
                <Button
                    variant="secondary"
                    onClick={onClose}
                    text="Отмена"
                    disabled={!!pending}
                />

                <Button
                    onClick={() => onConfirm({ email: normalizeEmail(email) })}
                    text={pending ? "Отправляем..." : "Отправить"}
                    disabled={confirmDisabled}
                />
            </div>
        </Modal>
    );
};

export default ResetUserPasswordModal;
